<!--票据打印页面-->
<template>
    <a-card :bordered="false" :class="{'abcdefg':true}">
      <div class="no-print" style="text-align: right;margin-bottom: 20px">
        <a-button v-print="'#printContent'" ghost type="primary">{{ $t('打印') }}</a-button>
      </div>
      <section ref="print" id="printContent" class="print-section">
          <!--
        <div style="text-align: center">
          <p style="font-size: 24px;font-weight: 800">{{ $t('大兴水厂用户缴费收据') }}</p>
        </div>
        -->
        <table id="table" style="height: 80mm;width:220mm;table-layout: fixed;">
            <tr>
            <td colspan="20" style="border-width: 0"><span style="font-size: 20px;font-weight: 800">{{ $t('额敏县众诚供排水有限责任公司销售凭证') }}</span></td>
          </tr>
          <tr>
            <td colspan="20" style="border-width: 0;text-align:left">{{ $t('日期：') }} {{model.updateTime?model.updateTime:model.createTime}}</td>
          </tr>
          <tr>
            <td colspan="3">{{ $t('用户编号') }}</td>
            <td colspan="5">{{model.meterUserId}}</td>
            <td colspan="3">{{ $t('用户地址') }}</td>
            <td colspan="9">{{model.userAreaName.slice(model.userAreaName.indexOf('-')+1,model.userAreaName.length)+'-'+model.userAddr}}</td>
            
           <!-- <td colspan="2">{{ $t('区域') }}</td>
            <td colspan="6">{{model.userAreaName}}</td> -->
          </tr>
          <tr>
            <td colspan="3">{{ $t('用户名') }}</td>
            <td colspan="7">{{model.userName}}</td>
            <td colspan="4">{{ $t('表编号') }}</td>
            <td colspan="6">{{model.meterId}}</td>
          </tr>
          <tr>
            <td colspan="3">{{ $t('价格名称') }}</td>
            <td colspan="3">{{ $t('综合单价/m³') }}</td>
            <td colspan="4">{{ $t('项目') }}</td>
            <td colspan="2">{{ $t('单价/m³') }}</td>
            <td colspan="2">{{ $t('购水量/m³') }}</td>
            <td colspan="6">{{ $t('金额') }}</td>
          </tr>
          <tr>
            <td colspan="3" rowspan="1">{{model.userPriceName}}</td>
            <td colspan="3" rowspan="1">{{model.userPriceTotal}}</td>
            <td colspan="4" class="borderWidth1">
              <div>{{ $t('净水费') }}</div>
              <template v-if="model.userPriceItem1Name">
                <!-- 存在污水处理 -->
                <div v-if="/污水处理/.test(model.userPriceItem1Name)"
                  style="line-height: 0.72; font-size: 10.5px; padding-top: 2px;display: block;" >
                  {{ model.userPriceItem1Name }}<br>
                  <span style="display: block; margin-top: 4px;">{{ $t('(按量的80%收取)') }}</span>
                </div>
                <div v-else-if="model.userPriceItem1Name">{{model.userPriceItem1Name}}</div>
              </template>

              <template v-if="model.userPriceItem2Name">
                <!-- 存在污水处理 -->
                <div v-if="/污水处理/.test(model.userPriceItem2Name)"
                  style="line-height: 0.65; font-size: 11px; padding-top: 4px;display: block;" >
                  {{ model.userPriceItem2Name }}<br>
                  <span style="display: block; margin-top: 4px;">{{ $t('(按量的80%收取)') }}</span>
                </div>
                <div v-else-if="model.userPriceItem2Name">{{model.userPriceItem2Name}}</div>
              </template>
            </td>
            <td colspan="2" class="borderWidth2">
              <!-- {{model.userPriceTotal - (model.userPriceCharge&&model.userPriceCharge)|formatDecimal(2)}} -->
              <div>{{setWaterPrice()}}</div>

              <template v-if="model.userPriceItem1Name">
                <!-- 存在污水处理 -->
                <div v-if="/污水处理/.test(model.userPriceItem1Name)">
                  {{  (Number(model.userPriceItem1) / 0.8).toFixed(2)  }}
                </div>
                <div v-else-if="model.userPriceItem1Name">{{model.userPriceItem1}}</div>
              </template>

              <template v-if="model.userPriceItem2Name">
                <!-- 存在污水处理 -->
                <div v-if="/污水处理/.test(model.userPriceItem2Name)">
                  {{  (Number(model.userPriceItem2) / 0.8).toFixed(2)  }}
                </div>
                <div v-else-if="model.userPriceItem2Name">{{model.userPriceItem2}}</div>
              </template>
            </td>
            <td colspan="2">
              <!-- {{model.userPriceTotal - (model.userPriceCharge&&model.userPriceCharge)|formatDecimal(2)}} -->
              <div>{{model.payWaterNum}}</div>
            </td>
            <td colspan="6" class="borderWidth3">
              <!-- {{model.payWaterNum * (model.userPriceTotal - (model.userPriceCharge&&model.userPriceCharge))|formatDecimal(2)}} -->
              <div>{{setWaterMoney()}}</div>
              <div v-if="model.userPriceItem1Name">{{model.payWaterNum * (model.userPriceItem1?model.userPriceItem1:0)|formatDecimal(2)}}</div>
              <div v-if="model.userPriceItem2Name">{{model.payWaterNum * (model.userPriceItem2?model.userPriceItem2:0)|formatDecimal(2)}}</div>
            </td>
          </tr>
          <tr>
            <td colspan="3">{{ $t('上次余额') }}</td>
            <td colspan="3">{{model.userPreAccountNum}}</td>
            <td colspan="4">{{ $t('实收金额') }}</td>
            <td colspan="4">{{model.userPayAccountNum}}</td>
            <td colspan="2">{{ $t('余额') }}</td>
            <td colspan="4">{{model.userNowAccountNum}}</td>
          </tr>
          <tr>
            <td colspan="3">{{ $t('大写金额') }}</td>
            <td colspan="17">{{model.userPayAccountNum|changeToChinese}}</td>
          </tr>
          <tr>
            <td colspan="14" style="border-width: 0;;text-align:left">
              {{ $t('打印日期：') }}{{moment().format('YYYY-MM-DD HH:mm:ss')}}
            </td>
            <td style="border-width: 0;text-align:left" colspan="4">{{ $t('操作员：') }}{{model.updateBy?model.updateBy:model.createBy}}</td>
          </tr>
        </table>
      </section>
    </a-card>
</template>
<script>
import { changeToChinese,formatDecimal } from '@/utils/util'
import {isUndefined,isNull} from '@/utils/validate'
import moment from "moment"
import { mapGetters } from 'vuex'
import {payTypeObj} from '@/utils/constants/commonConstant'
export default {
  filters: {changeToChinese,formatDecimal},
    props: {
        'model': Object
    },
    data() {
        return {
            visible: false,
            payType: payTypeObj
        }
    },
    mounted() {
      var children1 = document.querySelector('.borderWidth1').children;
      var children2 = document.querySelector('.borderWidth2').children;
      var children3 = document.querySelector('.borderWidth3').children;
      if(children1.length == 2){
        children1[1].style.borderBottom = 'none';
        children1[1].style.height = '50%';
        children1[0].style.height = '50%';
      }else if(children1.length == 1){
        children1[0].style.height = '100%';
      }
      if(children2.length == 2){
        children2[1].style.borderBottom = 'none';
        children2[1].style.height = '50%';
        children2[0].style.height = '50%';
      }else if(children2.length == 1){
        children2[0].style.height = '100%';
      }
      if(children3.length == 2){
        children3[1].style.borderBottom = 'none';
        children3[1].style.height = '50%';
        children3[0].style.height = '50%';
      }else if(children3.length == 1){
        children3[0].style.height = '100%';
      }
    },
    methods: {
        moment,
        ...mapGetters(["nickname", "avatar","userInfo"]),
        setWaterPrice(){
          if(!this.model.userPriceItem1 && !this.model.userPriceItem2){
            return this.model.userPriceTotal;
          }else if(this.model.userPriceItem1 && !this.model.userPriceItem2){
            return this.model.userPriceTotal - this.model.userPriceItem1;
          }else if(!this.model.userPriceItem1 && this.model.userPriceItem2){
            return this.model.userPriceTotal - this.model.userPriceItem2;
          }else if(this.model.userPriceItem1 && this.model.userPriceItem2){
            let a = this.model.userPriceTotal - this.model.userPriceItem1 - this.model.userPriceItem2
            return a.toFixed(2);
          }
        },
        setWaterMoney(){
          if(this.model.userPriceCharge){
            var money = this.model.payWaterNum * (this.model.userPriceTotal - this.model.userPriceCharge);
            if(money == 0){
              return money;
            }else{
              return money.toFixed(2);
            }
          }else{
            let pice = this.model.userPriceTotal;
            if(this.model.userPriceItem1){
              pice = pice - this.model.userPriceItem1;
            }
            if(this.model.userPriceItem2){
              pice = pice - this.model.userPriceItem2;
            }
            var money = this.model.payWaterNum * pice;
            if(money == 0){
              return money;
            }else{
              return money.toFixed(2);
            }
          }
        }
    }
}
</script>
<style>
#table td{text-align: center;border: 1px solid gray;}
.print-section{
  color: #000;
}
.borderWidth1{
  margin: 0;
  padding: 0;
}
.borderWidth1 div{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 33.33%;
}
.borderWidth1 div:nth-child(2) {
  border: 1px solid gray;
  border-left-width: 0;
  border-right-width: 0;
}
.borderWidth2{
  margin: 0;
  padding: 0;
}
.borderWidth2 div{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 33.33%;
}
.borderWidth2 div:nth-child(2) {
  border: 1px solid gray;
  border-left-width: 0;
  border-right-width: 0;
}
.borderWidth3{
  margin: 0;
  padding: 0;
}
.borderWidth3 div{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 33.33%;
}
.borderWidth3 div:nth-child(2) {
  border: 1px solid gray;
  border-left-width: 0;
  border-right-width: 0;
}
</style>